import { Job, JobStatus } from 'interfaces/job';

export const reportTabJobStatuses = [JobStatus.Pending, JobStatus.Running, JobStatus.Completed] as const;

export const getDefaultReportTabJobId = <JobInterface extends Pick<Job, 'id' | 'startedAt' | 'status'>>(
  jobs: JobInterface[],
  currentJobIdFromUrl?: string | null
) => {
  if (currentJobIdFromUrl) {
    return currentJobIdFromUrl;
  }

  const getStartedAtTimestamp = (job: JobInterface) => new Date(job.startedAt || 0).getTime();
  const sortedJobs = [...jobs].sort(
    (leftJob, rightJob) => getStartedAtTimestamp(rightJob) - getStartedAtTimestamp(leftJob)
  );
  const mostRecentCompletedJob = sortedJobs.find((job) => job.status === JobStatus.Completed);
  const mostRecentJob = sortedJobs[0];

  return mostRecentCompletedJob?.id || mostRecentJob?.id;
};
